//TODO: DisplayContent for UpdateEmail
//TODO: ErrorBoundaries for UpdateEmail

//TODO: DisplayContent for UpdatePassword
//TODO: ErrorBoundaries for UpdatePassword

//TODO: DisplayContent for UpdateIdentification
//TODO: ErrorBoundaries for UpdateIdentification

//TODO: DisplayContent for UpdateContactInformation
//TODO: ErrorBoundaries for UpdateContactInformation

//TODO: DisplayContent for OptinAccordian
//TODO: ErrorBoundaries for OptinAccordian

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    DeleteAccount,
    UpdateEmail,
    UpdatePassword,
    UpdateIdentification,
    UpdateContactInformation,
    getCMSObject,
    OptinAccordian,
    DisplayContent,
    ErrorBoundary,
    TeleScript,
    getConfigForComponent,
} from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

const MyProfilePage = ({ user, loading, config, cmsSourceFirebase, actions, match, optins }) => {
    useEffect(() => {
        actions.userActions.updateSection({ section: null, status: null, code: null });
    }, []);

    const path = match.path.replace('-', '');

    const updateContactInformationTelescript = getCMSObject('data.components.teleScripts.updateContactInfo.jsonBlock');
    const updateIdentificationTelescript = getCMSObject('data.components.teleScripts.updateIdentificationInfo.jsonBlock');
    const updateEmailTelescript = getCMSObject('data.components.teleScripts.MyProfileUpdateEmail.jsonBlock');
    const updatePasswordTelescript = getCMSObject('data.components.teleScripts.MyProfileUpdatePassword.jsonBlock');

    const deleteAccount = getConfigForComponent('deleteAccount', config);

    //? Collecting states for Update Contact Information
    let states = getCMSObject('data.sitewideSettings.states.jsonBlock');
    states = Array.isArray(states) ? states : [];

    //? Collecting genders for Update Identification
    let genders = getCMSObject('data.sitewideSettings.genders.jsonBlock');
    genders = Array.isArray(genders) ? genders : [];

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, path, match }}>
            <div className='my-profile-container container theme-form'>
                <div className='row justify-content-center'>
                    <div className='col-12 col-lg-10'>
                        <UpdateEmail
                            user={user}
                            loading={loading}
                            actions={actions}
                            telescript={updateEmailTelescript}
                            options={
                                config?.site?.components?.updateEmail ?? {
                                    variant: 'theme-primary',
                                    hasCollapser: true,
                                    showByDefault: true,
                                    hash: 'update-email',
                                }
                            }
                        />

                        <UpdatePassword
                            user={user}
                            loading={loading}
                            actions={actions}
                            telescript={updatePasswordTelescript}
                            options={
                                config?.site?.components?.updatePassword ?? {
                                    variant: 'theme-primary',
                                    hasCollapser: true,
                                    showByDefault: true,
                                    hash: 'update-password',
                                    minimumPasswordLength: 10,
                                }
                            }
                        />

                        <UpdateIdentification
                            user={user}
                            loading={loading}
                            actions={actions}
                            telescript={updateIdentificationTelescript}
                            editableFields={config?.site?.components?.updateIdentification?.editableFields ?? ['firstName', 'lastName', 'gender']}
                            genders={genders}
                            options={
                                config?.site?.components?.updateIdentification ?? {
                                    variant: 'theme-primary',
                                    hasCollapser: true,
                                    showByDefault: true,
                                    hash: 'update-identification',
                                }
                            }
                        />

                        <UpdateContactInformation
                            user={user}
                            loading={loading}
                            actions={actions}
                            telescript={updateContactInformationTelescript}
                            editableFields={
                                config?.site?.components?.updateContactInformation?.editableFields ?? ['address1', 'address2', 'city', 'state', 'zip', 'phone']
                            }
                            states={states}
                            options={
                                config?.site?.components?.updateContactInformation ?? {
                                    variant: 'theme-primary',
                                    hasCollapser: true,
                                    showByDefault: false,
                                    hash: 'update-contact-information',
                                }
                            }
                        />

                        <OptinAccordian actions={actions} user={user} optins={optins} heading='My Notifications' />

                        <DisplayContent note='Show Delete Account section' isVisible={deleteAccount?.enabled}>
                            <ErrorBoundary fallback={<TeleScript line={deleteAccount?.fallback} />} details={{ user, config }}>
                                <DeleteAccount
                                    user={user}
                                    loading={loading}
                                    cmsSourceFirebase={cmsSourceFirebase}
                                    actions={actions}
                                    telescript={deleteAccount?.telescript}
                                    options={
                                        deleteAccount?.config ?? {
                                            variant: 'theme-primary',
                                            hasCollapser: true,
                                            showByDefault: false,
                                            hash: 'delete-account',
                                        }
                                    }
                                />
                            </ErrorBoundary>
                        </DisplayContent>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyProfilePage);
